import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQCard from '../../components/card';
import UQGrid from '../../components/grid';
import UQButton from '../../components/button';
import UQSpacer from '../../components/spacer';
import UQRow from '../../components/row';
import UQCol from '../../components/col';
import UQIcon from '../../components/icon';
import { BREADCRUMB_ROOT } from '../../common/config';
import './style.scss';
import UQCode from '../../components/code';

const Home = () => {
  return (
    <>
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Home']} />
      <UQSpacer size="m" />
      <h1>Welcome to UniQ UI</h1>
      <UQSpacer size="m" />

      {/* Hero Section */}
      <UQCard>
        <div className="hero-section">
          <h2>Get Started with UniQ UI</h2>
          <UQSpacer size="s" />
          <p>
            UniQ UI is a modern SCSS styling library and React component library designed to help you build beautiful and functional user interfaces effortlessly.
          </p>
          <UQSpacer size="s" />
          <p>
            Build stunning user interfaces with our pre-designed components and styling utilities. Whether you're a beginner or an expert, UniQ UI has everything you need.
          </p>
          <UQSpacer size="m" />
          <UQButton
            type="primary"
            size="large"
            icon="plane"
            iconPosition="left"
            onClick={() => window.open('https://www.uniqconsulting.ch', '_blank')}
          >
            Learn More
          </UQButton>
        </div>
      </UQCard>
      <UQSpacer size="m" />

      {/* Prerequisites Section */}
      <UQGrid>
        <UQCard>
          <h2>Make sure before we get started</h2>
          <UQSpacer size="s" />
          <UQRow>
            <UQCol span={1}>
              <UQIcon icon="check-circle" />
            </UQCol>
            <UQCol span={11}>
              <p>Node.js installed on your system.{' '}
                <a href="https://nodejs.org/" target="_blank" rel="noopener noreferrer">
                  Download Node.js
                </a>
              </p>
            </UQCol>
          </UQRow>
          <UQSpacer size="xs" />
          <UQRow>
            <UQCol span={1}>
              <UQIcon icon="check-circle" />
            </UQCol>
            <UQCol span={11}>
              <p>Access to the Git server at{' '}
                <a href="https://git.uniqconsulting.ch" target="_blank" rel="noopener noreferrer">
                  git.uniqconsulting.ch
                </a>
              </p>
            </UQCol>
          </UQRow>
        </UQCard>
        <UQSpacer size="s" />

        {/* Installation Steps */}
        <UQCard>
          <h2>Installation Steps</h2>
          <UQSpacer size="s" />
          <ol>
            <li>
              Open your terminal and ensure you are connected to the Git server.
            </li>
            <UQSpacer size="m" />
            <li>
              Run the following command to install the package:
              <UQSpacer size="xs" />
              <UQCode code='npm install git+ssh://git@git.uniqconsulting.ch:dev/uniqconsulting-ui.git' />
              <UQSpacer size="xs" />
            </li>
            <UQSpacer size="xs" />
            <li>
              Import the components and styles into your project and start building!
            </li>
          </ol>
        </UQCard>
      </UQGrid>
      <UQSpacer size="m" />

      {/* Features Section */}
      <UQCard>
        <h2>Why Choose UniQ UI?</h2>
        <UQSpacer size="s" />
        <UQGrid>
          <div className="feature">
            <UQIcon icon="image" />
            <h3>Modern Design</h3>
            <UQSpacer size="xs" />
            <p>
              Beautifully crafted components with a focus on usability and aesthetics.
            </p>
          </div>
          <div className="feature">
            <UQIcon icon="code" />
            <h3>Developer Friendly</h3>
            <UQSpacer size="xs" />
            <p>
              Easy-to-use APIs and extensive documentation to get you started quickly.
            </p>
          </div>
          <div className="feature">
            <UQIcon icon="plane" />
            <h3>Performance Optimized</h3>
            <UQSpacer size="xs" />
            <p>
              Lightweight and fast components to ensure a smooth user experience.
            </p>
          </div>
        </UQGrid>
      </UQCard>
      <UQSpacer size="m" />

      {/* Call to Action */}
      <UQCard>
        <div className="cta-section">
          <h2>Ready to Build?</h2>
          <UQSpacer size="s" />
          <p>
            Start building your next project with UniQ UI today. Explore our components and see how easy it is to create stunning user interfaces.
          </p>
          <UQSpacer size="m" />
          <UQButton
            type="primary"
            size="large"
            icon="arrow-right"
            iconPosition="right"
            onClick={() => window.open('/components', '_self')}
          >
            Explore Components
          </UQButton>
        </div>
      </UQCard>
      <UQSpacer size="m" />
    </>
  );
};

export default Home;
